import { defineComponent as _defineComponent } from 'vue'
import MoreItems from '@sh/components/Utils/MoreItems.ts.vue';
import OptimizerIcon from '@sh/components/Utils/OptimizerIcon.ts.vue';
import TagCell from '@sh/components/Utils/Tags/TagCell.ts.vue';

interface Props {
  tags: Array<string>;
  isRemoveIconVisible: boolean;
  isTagPredefined?: string[];
}
interface Emits {
  (e: 'enableTagManagement'): void;
  (e: 'deleteTag', tag: string): void;
  (e: 'tagClicked'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TagsList.ts',
  props: {
    tags: null,
    isRemoveIconVisible: { type: Boolean },
    isTagPredefined: null
  },
  emits: ["enableTagManagement", "deleteTag", "tagClicked"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'enableTagManagement'): void;
  (e: 'deleteTag', tag: string): void;
  (e: 'tagClicked'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  tags: Array<string>;
  isRemoveIconVisible: boolean;
  isTagPredefined?: string[];
};





const isClearIconShown = (tag: string) => {
  if (props.isTagPredefined) {
    return !props.isTagPredefined.includes(tag);
  }
  return props.isRemoveIconVisible;
};

return { __sfc: true,props, emit, isClearIconShown, MoreItems, OptimizerIcon, TagCell }
}

})